import axios from "axios";
import { setCampLoading } from "./navigation";
const key = process.env.REACT_APP_API_KEY;

export const setLoading = (loading) => {
  return {
    type: "qIncidents/loading",
    payload: loading,
  };
};
export const storeQIncidents = (data) => {
  return {
    type: "qIncidents/store",
    payload: data,
  };
};
export const cleanQIncidents = () => {
  return {
    type: "qIncidents/clean",
  };
};

export const getQIncidents = (req) => {
  return async (dispatch, getState) => {
    // dispatch(setLoading(true))
    dispatch(storeQIncidents("loading"));

    let response = await axios.post(`/api/q_incindents?code=${key}`, {});
    dispatch(storeQIncidents(response.data));
  };
};
